import { Box, TextField, Typography, Alert } from '@mui/material';
import { usePlatformCharge } from 'admin/hooks/usePlatformCharge';
import { Button } from 'design-library';
import { useEffect, useState } from 'react';

export const PlatformChargeSettings = () => {
  const {
    // deletePlatformCharge,
    error,
    platformCharge,
    loading,
    savePlatformCharge,
  } = usePlatformCharge();
  const [inputCharge, setInputCharge] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const hasExistingValue =
    platformCharge !== null &&
    platformCharge !== undefined &&
    platformCharge !== 0;

  useEffect(() => {
    if (hasExistingValue) {
      setInputCharge(platformCharge.toString());
    } else {
      setInputCharge('');
    }
  }, [platformCharge, hasExistingValue]);

  const handleEdit = () => {
    setIsEditing(true);
    setSuccessMessage('');
  };

  const handleSet = () => {
    setIsEditing(true);
    setSuccessMessage('');
  };
  // const handleDelete = async () => {
  //   try {
  //     await deletePlatformCharge();
  //     setInputCharge('');
  //     setSuccessMessage('Platform charge deleted successfully!');
  //     setIsEditing(false);
  //   } catch (err) {
  //     console.error('Failed to delete platform charge:', err);
  //     alert('Failed to delete platform charge. Please try again.');
  //   }
  // };

  const handleSave = async () => {
    try {
      const charge = parseFloat(inputCharge);
      if (isNaN(charge) || charge < 0 || charge > 1) {
        alert('Please enter a valid percentage between 0.00 and 1.00');
        return;
      }
      await savePlatformCharge(charge);
      setSuccessMessage('Platform charge saved successfully!');
      setIsEditing(false);
    } catch (err) {
      console.error('Failed to save charge');
      alert('Failed to save platform charge. Please try again.');
    }
  };

  const handleCancel = () => {
    setIsEditing(false);

    if (hasExistingValue) {
      setInputCharge(platformCharge.toString());
    } else {
      setInputCharge('');
    }
    setSuccessMessage('');
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Typography>Loading settings...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="60vh"
      sx={{
        px: { md: 4, sm: 3, xs: 2 },
        py: { sm: 6,  xs: 3 },
      }}
    >
      <Box
        sx={{
          backgroundColor: 'background.paper',
          borderRadius: 2,
          boxShadow: 3,
          margin: '0 auto',
          p: 10,
          width: { md: '60%', sm: '80%', xs: '100%' },
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3 }}>
          Platform Charge Settings
        </Typography>
        <Box
          sx={{
            backgroundColor: 'rgba(102, 126, 234, 0.05)',
            border: '2px solid rgba(102, 126, 234, 0.1)',
            borderRadius: 3,
            mb: 4,
            p: 3,
          }}
        >
          {!isEditing ? (
            hasExistingValue ? (
              <>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  Current Platform Charge
                </Typography>
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  color="primary.main"
                  sx={{ fontSize: { sm: '3rem', xs: '2rem' } }}
                >
                  {(platformCharge * 100).toFixed(2)}%
                </Typography>
              </>
            ) : (
              <>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  No Platform Charge has been set yet
                </Typography>
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  color="primary.main"
                  sx={{ fontSize: { sm: '3rem', xs: '2rem' } }}
                >
                  {(0).toFixed(2)}%
                </Typography>
              </>
            )
          ) : null}
        </Box>
        <Box sx={{ mb: 3 }}>
          <TextField
            label="Platform Charge (as decimal, e.g., 0.05 for 5%)"
            type="number"
            inputProps={{
              max: 1,
              min: 0,
              step: 0.01,
            }}
            fullWidth
            value={inputCharge}
            onChange={(e) => setInputCharge(e.target.value)}
            disabled={!isEditing}
            variant="outlined"
            helperText={
              hasExistingValue && !isEditing
                ? `Current charge: ${(platformCharge * 100).toFixed(2)}%`
                : 'Please Enter value between 0.00 and 1.00'
            }
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
              },
            }}
          />
        </Box>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-start' }}>
          {!isEditing ? (
            <>
              {hasExistingValue ? (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleEdit}
                    sx={{ minWidth: 100 }}
                  >
                    Edit
                  </Button>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDelete}
                    sx={{ minWidth: 100 }}
                  >
                    Delete
                  </Button> */}
                </>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSet}
                  sx={{ minWidth: 100 }}
                >
                  Set
                </Button>
              )}
            </>
          ) : (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                sx={{ minWidth: 100 }}
              >
                Save
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCancel}
                sx={{ minWidth: 100 }}
              >
                Cancel
              </Button>
            </>
          )}
        </Box>

        {successMessage && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {successMessage}
          </Alert>
        )}
      </Box>
    </Box>
  );
};

export default PlatformChargeSettings;
